NtechApp.Collection = function($view) {
    var me = this;

    this._$view = null;

    this._touchClickEvent = null;

    this._$catalogInfo = null;
    //this._$leftParallaxOverlay = null;
    //this._$rightParallaxOverlay = null;

    this._$parallaxGrid = null;
    this._parallaxGrid = null;
    this._parallaxGridFilterNames = [];
    this._currentParallaxGridFilter = 0;
    this._showNextParallaxGridItemTimeout = null;

    this._css = {
        ids: {
        },

        classes: {
        },

        data: {
        }
    }

    this._construct = function () {
        me._$view = $view;

        me._$catalogInfo = me._$view.find(".catalogInfo");
        //me._$leftParallaxOverlay = $("<div class='collectionParallaxOverlay'></div>").appendTo("body");
        //me._$rightParallaxOverlay = $("<div class='collectionParallaxOverlay'></div>").appendTo("body");

        me._touchClickEvent = new NtechApp.TouchClickEvent();

        me._$parallaxGrid = me._$view.find(".parallaxGrid");

        me._createParallaxGrid();
        me._scheduleNextParallaxGridItemShow();
        me._centrifyGridContent();

        // Fix for parallax load
        me._createParallaxScroller();
        //me._createParallaxOverlays();
        //me._updateParallaxOverlays();

        setTimeout(function() {
            $(window).trigger("scroll");
            $(document).trigger(NtechApp.Collection.EVENT_DOCUMENT_SCROLL);
        }, 200);

        me._bindEvents();
    }

    this._bindEvents = function () {
        $(window).on(NtechApp.Collection.EVENT_DOCUMENT_RESIZE, function() {
            //me._updateParallaxOverlays();
            setTimeout(function() {
                $(window).trigger("scroll");
                $(document).trigger(NtechApp.Collection.EVENT_DOCUMENT_SCROLL);
                me._centrifyGridContent();
                //me._updateParallaxOverlays();
            }, 200);
        });

        $(document).on(NtechApp.Collection.EVENT_DOCUMENT_SCROLL, function() {
            //me._updateParallaxOverlays();
        });

        me._$view.on("mouseenter.NtechApp.Collection", ".gridItem", function(event) {
            $(this).find(".overlay").addClass("show");
            $(this).find(".name").addClass("selected");
        });

        me._$view.on("mouseleave.NtechApp.Collection", ".gridItem", function(event) {
            $(this).find(".overlay").removeClass("show");
            $(this).find(".name").removeClass("selected");
        });
    }

    this._unbindEvents = function () {
        $(window).off(NtechApp.Collection.EVENT_DOCUMENT_RESIZE);
        $(document).off(NtechApp.Collection.EVENT_DOCUMENT_SCROLL);
        me._$view.off("mouseenter.NtechApp.Collection");
        me._$view.off("mouseleave.NtechApp.Collection");
        $(".catalogInfo > .image").imageScroll("destroy");
        me._parallaxGrid.destruct();
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.Collection.EVENT_DOCUMENT_SCROLL = "scroll.NtechApp.Collection";
NtechApp.Collection.EVENT_DOCUMENT_RESIZE = "resize.NtechApp.Collection";

NtechApp.Collection.prototype._createParallaxScroller = function() {
    $(".catalogInfo > .image").imageScroll({
        holderMaxHeight: 430,
        container: $(".catalogInfo")
    });
};

NtechApp.Collection.prototype._centrifyGridContent = function() {
    var me = this;

    var $contentWrapper = this._$view.find(".catalogInfo");
    var $content = $contentWrapper.find(".content");

    var top = ($contentWrapper.height() / 2) - ($content.outerHeight() / 2);
    var left = ($contentWrapper.width() / 2) - ($content.outerWidth() / 2);
    $content.css({
        left: left + "px",
        top: top + "px"
    });
};

NtechApp.Collection.prototype._createParallaxGridFilters = function() {
    var me = this;

    var $gridItems = this._$parallaxGrid.find(".item");
    var parallaxGridFilters = {};

    var i = 0;
    var initialFilter = null;

    $.each($gridItems, function() {
        var filterName = "filter" + ++i;
        if(initialFilter == null)
            initialFilter = filterName;

        me._parallaxGridFilterNames.push(filterName);

        $(this).attr("data-item-filter-name", filterName);
        parallaxGridFilters[filterName] = function(item) {
            return $(item).attr("data-item-filter-name") == filterName;
        }
    });

    parallaxGridFilters.initial = initialFilter;

    return parallaxGridFilters;
};

NtechApp.Collection.prototype._createParallaxGrid = function() {
    var me = this;
    var parallaxGridFilters = this._createParallaxGridFilters();

    this._parallaxGrid = new Gridifier(this._$parallaxGrid, {
        class: "item",
        filter: parallaxGridFilters,
        toggle: "fade",
        toggleDuration: 1200,
        gridTransformTimeout: 0
    });

    this._parallaxGrid.onGridSizesChange(function() {
        me._centrifyGridContent();
    });
    this._parallaxGrid.onShow(function() {
        me._centrifyGridContent();
    });

    me._parallaxGrid.append(me._parallaxGrid.collectNew());
};

NtechApp.Collection.prototype._scheduleNextParallaxGridItemShow = function() {
    var me = this;
    this._showNextParallaxGridItemTimeout = setTimeout(function() {
        me._showNextParallaxGridTab.call(me);
    }, 4000);
};

NtechApp.Collection.prototype._showNextParallaxGridTab = function() {
    this._currentParallaxGridFilter++;
    if(this._currentParallaxGridFilter >= this._parallaxGridFilterNames.length)
        this._currentParallaxGridFilter = 0;

    this._showParallaxTab(this._currentParallaxGridFilter);
};

NtechApp.Collection.prototype._showParallaxTab = function(tabIndex) {
    this._currentParallaxGridFilter = tabIndex;
    this._parallaxGrid.setFilter(this._parallaxGridFilterNames[tabIndex]);
    this._scheduleNextParallaxGridItemShow();
};

//NtechApp.Collection.prototype._createParallaxOverlays = function() {
//    this._$leftParallaxOverlay.css({
//        position: "absolute",
//        left: "0px",
//        top: this._$collectionInfo.offset().top - 100 + "px",
//        width: "3%",
//        height: this._$collectionInfo.height() + 140 + "px",
//        //background: "white",
//        zIndex: "100"
//    });
//
//    this._$rightParallaxOverlay.css({
//        position: "absolute",
//        right: "0px",
//        top: this._$collectionInfo.offset().top - 100 + "px",
//        width: "3%",
//        height: this._$collectionInfo.height() + 140 + "px",
//        //background: "white",
//        zIndex: "100"
//    });
//};
//
//NtechApp.Collection.prototype._updateParallaxOverlays = function() {
//    this._$leftParallaxOverlay.css({
//        top: this._$collectionInfo.offset().top - 100 + "px",
//        height: this._$collectionInfo.height() + 140 + "px"
//    });
//    this._$rightParallaxOverlay.css({
//        top: this._$collectionInfo.offset().top - 100 + "px",
//        height: this._$collectionInfo.height() + 140 + "px"
//    });
//};